// extracted by mini-css-extract-plugin
module.exports = {"available-translations":"AddTranslation_available-translations__3f0hl"};